"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "loro-ciuffenna": {
    "4fdf5e53": [{
      "hkey": "ebf04738",
      "slug": "chiassaia-la-villa",
      "name": "Chiassaia-La Villa",
      "primary": true,
      "skipSearch": false
    }],
    "chiassaia": [{
      "hkey": "ebf04738",
      "slug": "chiassaia-la-villa",
      "name": "Chiassaia-La Villa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9dc01f8d": [{
      "hkey": "ca917ee0",
      "slug": "casamona-faeto-pratovalle",
      "name": "Casamona-Faeto-Pratovalle",
      "primary": true,
      "skipSearch": false
    }],
    "faeto": [{
      "hkey": "ca917ee0",
      "slug": "casamona-faeto-pratovalle",
      "name": "Casamona-Faeto-Pratovalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5a788721": [{
      "hkey": "02c610ca",
      "slug": "loro-ciuffenna",
      "name": "Loro Ciuffenna",
      "primary": true,
      "skipSearch": false
    }],
    "querceto": [{
      "hkey": "02c610ca",
      "slug": "loro-ciuffenna",
      "name": "Loro Ciuffenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "78738e36": [{
      "hkey": "02c610ca",
      "slug": "loro-ciuffenna",
      "name": "Loro Ciuffenna",
      "primary": true,
      "skipSearch": false
    }],
    "setteponti": [{
      "hkey": "02c610ca",
      "slug": "loro-ciuffenna",
      "name": "Loro Ciuffenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c7729fa3": [{
      "hkey": "7bd8a8c6",
      "slug": "casale-la-casa-trappola",
      "name": "Casale-La Casa-Trappola",
      "primary": true,
      "skipSearch": false
    }],
    "trappola": [{
      "hkey": "7bd8a8c6",
      "slug": "casale-la-casa-trappola",
      "name": "Casale-La Casa-Trappola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;